import SendNotes from './SendNotes'
export default SendNotes
